const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

export const getLocalDateOnly = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const normalizeDateOnly = (value) => {
  if (value === undefined || value === null) return "";
  const match = String(value).trim().match(DATE_ONLY_PATTERN);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : "";
};

export const formatDateOnlyPtBr = (value) => {
  const normalized = normalizeDateOnly(value);
  if (!normalized) return "";
  const [year, month, day] = normalized.split("-");
  return `${day}/${month}/${year}`;
};
